import React from "react";
import { useTranslation } from "react-i18next";
import { CONSTANTS, JOB_PANEL_TABS } from "@constants";
import { bindActionCreators } from "redux";
import * as rightSideBarActions from "../../../modules/rightSideBar";
import { useDispatch } from "react-redux";
import { getUrlInfo } from "../../../lib/mime/mime";
import { IconInfoCircle } from "@mzc-cloudplex/icons";
import useMyJobs from "@hooks/useMyJobs";

const BucketLockInfoMessage = ({ folders, fileName, totalCount, isDirectDownloadMissMatchRegion }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const RightSideBarActions = bindActionCreators(rightSideBarActions, dispatch);

    const urlInfo = getUrlInfo(fileName);
    const { openMyJobs } = useMyJobs({});

    const openDownloadRightSideBar = () => {
        openMyJobs(JOB_PANEL_TABS.DOWNLOAD);
    };

    return (
        <div>
            <p className="title">
                <IconInfoCircle size={16} htmlColor={`#fff`} />
                <span>
                    {t(
                        "common::msg::This bucket is locked by another user and can only be downloaded.",
                        `This bucket is locked by another user and can only be downloaded.`,
                    )}
                </span>
            </p>
        </div>
    );
};
export default BucketLockInfoMessage;
